var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-g-editor',{staticClass:"work-flow-graph",attrs:{"id":"vg-editor"}},[_c('flow',{attrs:{"align":{ item: 'vertical', grid: 'cc' },"graph":{ mode: 'readOnly' },"shortcut":{ zoomIn: true, zoomOut: true },"id":"flow-graph","grid":_vm.grid,"data":_vm.graphData}}),_c('flow-custom-node'),_c('flow-action-custom-node')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }